import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import adminSlice from "./admins/admin.slice";
import appSlice from "./app/app.slice";
import authSlice from "./auth/auth.slice";
import imamSpeakersSlice from "./imamSpeakers/imamSpeakers.slice";
import memberSlice from "./members/member.slice";
import moderationSlice from "./moderation/moderation.slice";
import muqabalasSlice from "./muqabalas/muqabalas.slice";
import settingsSlice from "./settings/settings.slice";
import subscriptionReducer from "./subscription/subscription.slice";
import tmpSlice from "./tmp/tmp.slice";

export const persistConfig = {
  key: "zawaj_sounnah_backoffice",
  storage,
  whitelist: ["app", "auth", "settings", "imamSpeakers", "tmp"],
  blacklist: [],
};

const topReducer = combineReducers({
  app: appSlice,
  auth: authSlice,
  members: memberSlice,
  moderations: moderationSlice,
  admins: adminSlice,
  settings: settingsSlice,
  muqabalas: muqabalasSlice,

  imamSpeakers: imamSpeakersSlice,
  tmp: tmpSlice,
  subscription: subscriptionReducer,
});

const rootReducer = (state: any, action: any) => {
  return topReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
